// Helper function to convert table name to URL-friendly format
export const createSlugForTableName = (tableName) => {
  return tableName
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9_]/g, "");
};
